import React from "react";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <main className="pt-24 md:pt-32 pb-24" data-testid="about-page">
      <section className="px-6 md:px-12 lg:px-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <p className="text-[11px] uppercase tracking-nav text-[#5C1A1B]">Our Story</p>
          <h1 className="font-serif text-5xl md:text-6xl mt-4 leading-[1.05]">Two decades. Twelve hands. One stitch at a time.</h1>
          <div className="mt-8 space-y-6 text-[15px] leading-relaxed text-[#4A4A4A]">
            <p>Dabkazari began in 2006 in a two-room karkhana off Chandni Chowk, when a small team of karigars set out to keep the languishing art of dabka embroidery alive. Two decades later, we still make every piece the slow way — one stitch, one story at a time.</p>
            <p>Our lehengas take between 240 and 600 karigar-hours to embroider. Our sarees are finished with mukaish shimmer applied by hand while the silk lies on wooden frames. Nothing here is done by machine.</p>
            <p>We ship to over 40 countries and every piece is inspected, folded in muslin, and packed with the karigar's initials tucked into the lining.</p>
          </div>
          <Link to="/collections/bridal" className="mt-10 inline-block btn-editorial">See the Bridal Edit</Link>
        </div>
        <div className="md:col-span-7">
          <img src="https://images.unsplash.com/photo-1763400234383-8b9ecbb9c043?crop=entropy&cs=srgb&fm=jpg&w=1200&h=1400&q=85" alt="Craftsmanship" className="w-full h-full object-cover aspect-[4/5]" />
        </div>
      </section>

      <section className="mt-24 px-6 md:px-12 lg:px-16 grid md:grid-cols-3 gap-10">
        {[
          { title: "Handcraft only", text: "No machines. Ever. Every metallic thread is couched by hand on a wooden karchoub frame." },
          { title: "Slow atelier", text: "We drop small, considered edits — never fast fashion. If something is sold out, it may return next season." },
          { title: "Made in India", text: "Designed and made in Delhi, shipped worldwide. Every karigar we work with is paid above the local wage benchmark." },
        ].map((t) => (
          <div key={t.title}>
            <p className="font-serif text-2xl">{t.title}</p>
            <p className="mt-3 text-sm text-[#4A4A4A] leading-relaxed">{t.text}</p>
          </div>
        ))}
      </section>
    </main>
  );
}
